import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';

const NAVY = '#0d2137';
const GREEN = '#16a34a';

export default function SolvixVitals() {
  const [vitals, setVitals] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | copied | error

  const buildClipboardText = (v) => {
    const lines = [];
    if (v.heartRate)   lines.push(`HR : ${Math.round(v.heartRate)}`);
    if (v.spo2)        lines.push(`SpO2 : ${Math.round(v.spo2)}`);
    if (v.systolicBp)  lines.push(`SYS : ${Math.round(v.systolicBp)}`);
    if (v.diastolicBp) lines.push(`DIA : ${Math.round(v.diastolicBp)}`);
    if (v.temperature) lines.push(parseFloat(v.temperature).toFixed(1));
    if (v.weight)      lines.push(`WEIGHT : ${parseFloat(v.weight).toFixed(1)}`);
    return lines.join('\n');
  };

  const loadAndCopy = useCallback(async () => {
    setStatus('loading');
    try {
      const res = await fetch('/api/solvix/vitals');
      if (!res.ok) { setStatus('error'); return; }
      const data = await res.json();
      setVitals(data);
      const text = buildClipboardText(data);
      await navigator.clipboard.writeText(text);
      setStatus('copied');
      toast.success('✓ Vitals copied! Click "Import from Solvix" on HIMS');
    } catch {
      setStatus('error');
    }
  }, []);

  useEffect(() => { loadAndCopy(); }, [loadAndCopy]);

  const row = (label, value, unit) => value ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #e2e8f0' }}>
      <span style={{ fontWeight: 600, color: '#374151', fontSize: 14 }}>{label}</span>
      <span style={{ fontWeight: 800, fontSize: 20, color: NAVY }}>{value} <span style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>{unit}</span></span>
    </div>
  ) : null;

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, maxWidth: 420, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.1)' }}>

        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>📲</div>
          <h2 style={{ margin: 0, color: NAVY, fontSize: 20, fontWeight: 800 }}>Solvix Vitals</h2>
          <p style={{ margin: '6px 0 0', color: '#64748b', fontSize: 13 }}>DHA Medical Centre</p>
        </div>

        {status === 'loading' && (
          <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>Loading vitals...</p>
        )}

        {status === 'copied' && vitals && (
          <>
            <div style={{ background: '#f0fdf4', border: '1.5px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', marginBottom: 18, textAlign: 'center' }}>
              <span style={{ color: GREEN, fontWeight: 700, fontSize: 14 }}>✓ Vitals copied to clipboard</span><br />
              <span style={{ color: '#64748b', fontSize: 12 }}>Now click "Import from Solvix" on HIMS register page</span>
            </div>

            <div style={{ marginBottom: 20 }}>
              {row('Heart Rate', vitals.heartRate && Math.round(vitals.heartRate), 'bpm')}
              {row('SpO2', vitals.spo2 && Math.round(vitals.spo2), '%')}
              {row('Systolic BP', vitals.systolicBp && Math.round(vitals.systolicBp), 'mmHg')}
              {row('Diastolic BP', vitals.diastolicBp && Math.round(vitals.diastolicBp), 'mmHg')}
              {row('Temperature', vitals.temperature && parseFloat(vitals.temperature).toFixed(1), '°C')}
              {row('Weight', vitals.weight && parseFloat(vitals.weight).toFixed(1), 'kg')}
            </div>

            <button onClick={loadAndCopy}
              style={{ width: '100%', padding: '10px', background: 'transparent', color: '#64748b', border: '1.5px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
              Copy Again
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <p style={{ textAlign: 'center', color: '#ef4444', fontSize: 14, marginBottom: 16 }}>
              No vitals found — send from Solvix app first.
            </p>
            <button onClick={loadAndCopy}
              style={{ width: '100%', padding: '12px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
